import { expandRoleAliases, normalizeRoleKey } from "./roleHelpers.mjs";

// Oglindește `backend/ncrm/privacy/access.js`: rolurile de manager Privacy se
// potrivesc **literal**, fără expandare de aliasuri. `useradmin-default`
// expandează la `admin` pentru rutele vechi, dar nu este manager Privacy — dacă
// am expanda aici, UI-ul i-ar arăta acțiuni care primesc inevitabil `403`.
export const PRIVACY_MANAGER_ROLES = Object.freeze(["admin", "miniadmin", "privacy-manager"]);

export const readStoredPrivacyRoleKeys = () => {
  if (typeof window === "undefined" || !window.localStorage) return [];
  const roleKeys = [];
  const pushRole = (value) => {
    const normalized = normalizeRoleKey(value);
    if (normalized) roleKeys.push(normalized);
  };

  try {
    pushRole(window.localStorage.getItem("user-role"));
    pushRole(window.localStorage.getItem("user-primary-role"));
    const rawRoles = JSON.parse(window.localStorage.getItem("user-roles") || "[]");
    if (Array.isArray(rawRoles)) {
      rawRoles.forEach((entry) => pushRole(
        typeof entry === "string" ? entry : entry?.key || entry?.role || entry?.name
      ));
    }
  } catch {
    return [...new Set(roleKeys)];
  }

  return [...new Set(roleKeys)];
};

export const hasPrivacyManagerRole = (roleKeys = readStoredPrivacyRoleKeys()) => {
  const roles = new Set((Array.isArray(roleKeys) ? roleKeys : [])
    .map(normalizeRoleKey)
    .filter(Boolean));
  return PRIVACY_MANAGER_ROLES.some((role) => roles.has(role));
};

// Oglindește `hasRegistryAccess` din `backend/ncrm/privacy/access.js`: managerii Privacy literal,
// plus rolurile CRM care se expandează la `crm-operator`. Acțiunile Privacy din fișa unui record
// (de exemplu retrimiterea DOI, S6.5) apar numai lor; `crm-caller`/`caller` văd fișa, nu acțiunea.
export const hasPrivacyRegistryRole = (roleKeys = readStoredPrivacyRoleKeys()) => {
  const literal = new Set((Array.isArray(roleKeys) ? roleKeys : []).map(normalizeRoleKey).filter(Boolean));
  if (PRIVACY_MANAGER_ROLES.some((role) => literal.has(role))) return true;
  return [...literal].flatMap((role) => expandRoleAliases(role)).includes("crm-operator");
};

// Paginile de record (`/ncrm/people/:id`, `/ncrm/companies/:id`) nu sunt deschise
// pentru `privacy-manager`, deși acesta vede registrul. Un rând clicabil l-ar
// redirecționa tăcut — un link mort. Oglindește `NCRM_CONTACT_DETAILS_ROLES` din
// router, fără aliasul `useradmin-default`, care oricum nu ajunge în workspace.
const RECORD_ACCESS_ROLES = Object.freeze(["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller", "caller"]);

export const hasRecordAccess = (roleKeys = readStoredPrivacyRoleKeys()) => {
  const roles = new Set((Array.isArray(roleKeys) ? roleKeys : [])
    .map(normalizeRoleKey)
    .filter((role) => role && role !== "useradmin-default")
    .flatMap((role) => expandRoleAliases(role)));
  return RECORD_ACCESS_ROLES.some((role) => roles.has(role));
};
